import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  exportTimeKeepingHRStart,
  exportTimeKeepingHRSuccess,
  exportTimeKeepingHRFailed,
} from "../redux/exportTimeKeepingHR";

import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";
import { SCREEN } from "helper/roleChecker/Screens";
import { formFilterTimeKeepingHRSelector } from "../redux/selector";
import { exportTimeKeepingHRApi } from "core/http/service/timeKeeping";
import { toast } from "react-toastify";

function* exportTimeKeepingHRWork() {
  const { offset, limit } = yield select(
    controlInfinitiveScrollSelector("timeKeepingHR")
  );
  const form = yield select(formFilterTimeKeepingHRSelector);

  const params = { offset, limit, ...form };
  try {
    const res = yield call(exportTimeKeepingHRApi, {
      ...params,
      screenCode: SCREEN.IP_021,
    });

    const blob = new Blob([res], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Create a URL for the blob
    const url = window.URL.createObjectURL(blob);

    // Create a link element
    const a = document.createElement("a");
    a.href = url;
    a.download = `Bảng_tổng_hợp_chấm_công_24/${form?.month - 1}-24/${form?.month}.xlsx`; // Name of the file to download

    // Append link to body and trigger download
    document.body.appendChild(a);
    a.click();

    // Clean up
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

    yield put({
      type: exportTimeKeepingHRSuccess.type,
    });
  } catch (error: any) {
    yield put({
      type: exportTimeKeepingHRFailed.type,
    });
    toast.error("Đã có lỗi xảy ra");
  }
}

function* watchExportTimeKeepingHR() {
  yield takeLatest(exportTimeKeepingHRStart.type, exportTimeKeepingHRWork);
}

export default function* exportTimeKeepingHRSaga() {
  yield all([watchExportTimeKeepingHR()]);
}
